import { buildReducer } from './buildReducer';

export const trustFundsReducer = buildReducer({ fetchAction: 'TRUST_FUNDS_FETCHED' });
export const annuitiesReducer = buildReducer({ fetchAction: 'ANNUITIES_FETCHED' });
export const pensionsReducer = buildReducer({ fetchAction: 'PENSIONS_FETCHED' });
export const unclassifiedIncomesReducer = buildReducer({
  fetchAction: 'UNCLASSIFIED_INCOMES_FETCHED',
});
